export default __webpack_public_path__ + "static/media/Custom-HUD-02.3135a078.jpg";